import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'nominas/nominas-plazas-otros-pagos';

/**
 * GET Nominas Plazas Otros Pagos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getNominasPlazasOtrosPagos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Nomina Plaza Otro Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getNominaPlazaOtroPago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Nomina Plaza Otro Pago
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postNominaPlazaOtroPago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Nomina Plaza Otro Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchNominaPlazaOtroPago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Nomina Plaza Otro Pago
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteNominaPlazaOtroPago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
